import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { UseFormReturn } from 'react-hook-form'

import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'

export interface GetFormFieldsForWithdrawDialogParams {
  form: UseFormReturn<AssetInputSchema>
  tokenRepository: TokenRepository
  stakingToken: Token
  staked: NormalizedNumber
}

export function getFormFieldsForUnstakeDialog({
  form,
  tokenRepository,
  stakingToken,
  staked,
}: GetFormFieldsForWithdrawDialogParams): FormFieldsForDialog {
  // eslint-disable-next-line func-style
  const changeAsset = (newSymbol: TokenSymbol): void => {
    form.setValue('symbol', newSymbol)
    form.setValue('value', '')
    form.setValue('isMaxSelected', false)
    form.clearErrors()
  }

  const { symbol, value } = form.getValues()
  const token = tokenRepository.findOneBySymbol(symbol)

  const usdStakedBalance = stakingToken.toUSD(staked)
  const tokenBalance = usdStakedBalance.div(token.unitPriceUsd)

  return {
    selectedAsset: token,
    selectedAssetBalance: tokenBalance,
    value,
    changeAsset,
    maxValue: tokenBalance,
    maxSelectedFieldName: 'isMaxSelected',
  }
}
